import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Soft UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";

import ApiService from "services/ApiService";

function VerifyPhone() {
  const [phoneVerified, setPhoneVerified] = useState(false);
  const { d1, d3, d4, d5 } = typography;
  const { token } = useParams();

  const verifyPhone = async () => {
    const response = await ApiService.getData(`/api/v1/users/verify-phone?token=${token}`);
    if (response) setPhoneVerified(true);
  };

  useEffect(() => {
    verifyPhone();
  }, []);

  return (
    <PageLayout white>
      <SoftBox my={24} height="calc(100vh - 24rem)">
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          {!phoneVerified ? (
            <Grid item xs={11} sm={9} container alignItems="center">
              <Grid item xs={12} lg={6}>
                <SoftBox
                  fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
                  lineHeight={1.2}
                >
                  <SoftTypography variant="inherit" color="error" textGradient fontWeight="bold">
                    Αποτυχία!
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={1} mb={2}>
                  <SoftTypography variant="body1" color="text">
                    Το τηλέφωνό σας δεν επαληθεύτηκε! Πιθανόν ο σύνδεσμος έχει λήξει. Παρακαλώ
                    δοκιμάστε εκ νέου.
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={4} mb={2}>
                  <SoftButton component={Link} to="/login" variant="gradient" color="dark">
                    ΣΥΝΔΕΣΗ
                  </SoftButton>
                </SoftBox>
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={11} sm={9} container alignItems="center">
              <Grid item xs={12} lg={6}>
                <SoftBox
                  fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
                  lineHeight={1.2}
                >
                  <SoftTypography variant="inherit" color="success" textGradient fontWeight="bold">
                    Επιτυχία!
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={1} mb={2}>
                  <SoftTypography variant="body1" color="text">
                    Το τηλέφωνό σας επαληθεύτηκε!
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={4} mb={2}>
                  <SoftButton component={Link} to="/login" variant="gradient" color="dark">
                    ΣΥΝΔΕΣΗ
                  </SoftButton>
                </SoftBox>
              </Grid>
            </Grid>
          )}
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default VerifyPhone;
